export const GET_ORGANIZATION_USERS = "GET_ORGANIZATION_USERS";
export const GET_ORGANIZATION_USER_BY_ID = "GET_ORGANIZATION_USER_BY_ID";
export const UPDATE_ORGANIZATION_USER = "UPDATE_ORGANIZATION_USER";
export const DELETE_ORGANIZATION_USER = "DELETE_ORGANIZATION_USER";
export const CREATE_ORGANIZATION_USER = "CREATE_ORGANIZATION_USER";
